import { RfpTypes } from './rfp-types.enum';
import { RfpStatuses } from './rfp-statuses.enum';
import { RestCategory } from './rest-category';
import { RfpBuyerIdentifier } from '../rfp-spend/buyer-identifier';
import { SubmittedBy } from './submitted-by';
import { RequestedBy } from './requested-by';
import { Identifier } from '../identifiers/identifiers';

// Note: I'm not pretending this is a complete type in this case, it just has a few common things you might want
// from the returned data and everybody hates it when I put "any" as a type. So I'm filling in some because whomever
// did RestRfp didn't include offers at all.
export interface RestOffer {
  buyer: {
    id: number;
    name: string;
  };
  id: number;
  name: string;
  seller: {
    id: number;
    name: string;
  };
  status: string;
}

export class RestRfp {
  // From Backend
  buyer!: RfpBuyerIdentifier;
  category!: RestCategory;
  contractDurations!: number[];
  contractEffectiveDates!: number[];
  groupRfp!: boolean;
  hasPartialCategories!: boolean;
  id!: number;
  numberOfParticipants!: number;
  numberOfSellers!: number;
  numberOfStandardCategories!: number;
  numberOfSystems!: number;
  numberOfUnspscs!: number;
  offers!: Array<RestOffer>;
  preferredContractDuration!: number;
  preferredContractEffectiveDate!: number;
  purchasePlanAccessible!: boolean;
  requestedBy?: RequestedBy;
  sellers!: Array<Identifier>;
  sendDate?: Date;
  status!: RfpStatuses;
  submissionDate?: Date;
  submittedBy?: SubmittedBy;
  type!: RfpTypes;
  responseStatus?: string;

  // This is the original data from the server, untouched.
  rfpFromServer: unknown;

  // Calculated
  spendStartDate: Date;
  spendEndDate: Date;
  createdBy: string;

  constructor(data: unknown) {
    Object.assign(this, data);

    // Save off the original data with no modifications.
    this.rfpFromServer = data;

    // Overide these with the Date versions for easier coding elsewhere
    // TODO: These should move to moment to handle timezones
    if (this.sendDate) {
      this.sendDate = new Date(this.sendDate);
    }
    if (this.submissionDate) {
      this.submissionDate = new Date(this.submissionDate);
    }

    // Calculate calculated fields
    // TODO: Once moment is used copy these functions back from old codebase.
    // src/main/webapp/src/typescript/modules/core/layout/header/headerDetailsRfp.factory.ts
    this.spendStartDate = this.calculateSpendStartDate();
    this.spendEndDate = this.calculateSpendEndDate();
    this.createdBy = this.calculateCreatedBy();
  }

  private calculateSpendStartDate(): Date {
    const holder: Date = this.sendDate || this.submissionDate || new Date();
    return new Date(holder.getFullYear(), holder.getMonth() - 14, 1);
  }

  private calculateSpendEndDate(): Date {
    const holder: Date = this.sendDate || this.submissionDate || new Date();
    return new Date(holder.getFullYear(), holder.getMonth() - 2, 0);
  }

  private calculateCreatedBy(): string {
    if (this.submittedBy) {
      return this.submittedBy.emailAddress;
    }
    if (this.requestedBy) {
      return this.requestedBy.email;
    }
    return 'N/A';
  }
}
